import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-br from-slate-900 via-gray-900 to-black text-gray-300 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,184,166,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(20,184,166,0.05)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-xl">
                <span className="text-white font-bold text-2xl">F</span>
              </div>
              <div>
                <div className="text-2xl font-black text-white">Finsage</div>
                <div className="text-sm text-teal-300 font-medium">Mare Labs LLP</div>
              </div>
            </div>
            <p className="text-lg text-gray-300 mb-8 max-w-lg leading-relaxed">
              Empowering financial institutions with secure, compliant digital onboarding solutions.
              Transform your customer experience with our modern account opening platform.
            </p>
            <div className="flex space-x-6">
              <a href="mailto:contact@finsagemarelabs.com" className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center hover:bg-teal-600 hover:scale-110 smooth-transition group" title="General Inquiries">
                <Mail className="w-6 h-6 group-hover:text-white" />
              </a>
              <a href="#" className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center hover:bg-blue-600 hover:scale-110 smooth-transition group">
                <Linkedin className="w-6 h-6 group-hover:text-white" />
              </a>
              <a href="#" className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center hover:bg-blue-400 hover:scale-110 smooth-transition group">
                <Twitter className="w-6 h-6 group-hover:text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/product" className="text-sm hover:text-teal-400 transition-colors">
                  Product
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-teal-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/integrations" className="text-sm hover:text-teal-400 transition-colors">
                  Integrations
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm hover:text-teal-400 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm hover:text-teal-400 transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-teal-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm hover:text-teal-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm hover:text-teal-400 transition-colors">
                  Terms of Use
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Finsage Mare Labs LLP. All rights reserved.
            </p>
            <div className="text-sm text-gray-400 mt-4 md:mt-0 space-y-1">
              <p>General: <a href="mailto:contact@finsagemarelabs.com" className="hover:text-teal-400 transition-colors">contact@finsagemarelabs.com</a></p>
              <p>Sales: <a href="mailto:sales@finsagemarelabs.com" className="hover:text-teal-400 transition-colors">sales@finsagemarelabs.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};